import React, { Component } from 'react';
import {NavLink, Link} from "react-router-dom";
import logodashheader  from '../Assets/logo-dash-header.png';
import FeedBackImg from '../Assets/ratings-review.png';
import Footer from "../Components/footer";
import  Header  from "../Components/header";
import SideBar from "../Components/sidebar";
import DataTable from "../Components/datatablerepository";
import { RedirectNotLogin, RedirectContractor, AlertMessageOut } from "../Components/function";

class Repository extends Component{

  constructor(props){
    super(props);
    
    this.state = {
      userID : '',
      scriptID: '',
      file: '',
      message: '',
    }
    }
    
    componentDidMount(){
      RedirectNotLogin();
      RedirectContractor();
    }

    componentDidUpdate() {
      RedirectNotLogin();
      RedirectContractor();
    }
 
  render(){
    return (
        <div className="App AppWrap">
    
    <Header self={this}/>
    <SideBar self={this}/>
    

    <div className="App iBG dash-dash">
    <div className="containers">
   
    <div className="card-lt-wrap hidden">
    <div className="card-lt breadcrumb">
  <h1><NavLink to="/dashboard">Dashboard</NavLink> <i className="fa fa-chevron-right"></i> Repository</h1>
  </div>
  </div>


  <div className="card-lt-wrap">
    <div className="card-lt">

     {AlertMessageOut(this)}

     <DataTable 
     route="repository"
     badge={['', '', '', '']}
     thclassX={['', 'nowrap', 'nowrap']}
     th={
        ['Title', 'File ID', 'Type', 'Uploaded Date']
     }
     td={
        ['title', 'fileid', 'type', 'added']
    }
     cmd="repository"
     self={this}
     />

    
     </div>

        <Footer classX="dash-footer"/>

    </div>
    
    </div>

    </div>

    </div>
    );
}

}

export default Repository;